import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import your components
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import Hero from "./components/Hero/Hero";
import WeeklyProgram from "./components/WeeklyProgram/WeeklyProgram";
import Highlights from "./components/Highlights/Highlights";
import Gallery from "./components/Gallery/Gallery";
import Contact from "./components/Contact/Contact";
import UpcomingEvents from "./components/UpcomingEvents/UpcomingEvents";
import Timeline from "./components/Timeline/Timeline";
import Impressum from "./pages/Impressum/Impressum";
import Datenschutz from "./pages/Datenschutz/Datenschutz";
import AboutUs from "./components/AboutUs/AboutUs";
import About from "./pages/AboutUsex/AboutUsex";
import SportgruppePage from "./pages/SportgruppePage/SportgruppePage";
import ContactPage from "./pages/Contact/Contact";
import VfbNews from "./components/VfbNews/VfbNews";

// --- Import the new ScrollToTop component ---
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function App() {
  return (
    <Router basename="/">
      {/* --- Add the ScrollToTop component here --- */}
      <ScrollToTop />
      
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <WeeklyProgram />
              <AboutUs />
              <VfbNews />
              <Timeline />
              <Highlights />
              <Gallery />
              <Contact />
            </>
          }
        />
        <Route path="/about-us" element={<About />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/sportgruppe/:id" element={<SportgruppePage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;